import {h, Fragment} from "preact"
import { useAppState, HistoryElement } from "@nosto/preact"
import { useEffect, useState, useRef } from "preact/hooks";
import { closeSearchOverlay } from "../helpers"

import { defaultConfig, popularSearches, HISTORY_DROPDOWN_REC_ID } from "../config"

export default function History() {
    const { historyItems } = useAppState();
    const [ maxHeight, setMaxHeight ] = useState(window.innerHeight + 'px');
    const keywordsRef = useRef(null);

    useEffect(() => {
        const searchHeader = document.querySelector('.search-modal__content-bottom');
        if(!searchHeader) return;
        setMaxHeight((window.innerHeight - searchHeader.offsetHeight) + 'px')
    }, []);

    useEffect(() => {
        if(!window.nostojs) return;
        window.nostojs(api => {
            api
            .createRecommendationRequest({ includeTagging: true })
            .setElements([ HISTORY_DROPDOWN_REC_ID ])
            .load({ skipPageViews: true, skipEvents: true })
        })
    }, [])

    useEffect(() => {
        if(!keywordsRef.current) return;
        const handleClick = (event) => {
            if(
                keywordsRef.current.contains(event.target) &&
                event.target.closest('.ns-autocomplete-element')
            ) {
                closeSearchOverlay();
            }
        }
        keywordsRef.current.addEventListener('click', handleClick);
        return () => keywordsRef.current.removeEventListener('click', handleClick);
    }, [])

    return (
        <div class="ns-autocomplete ns-history block absolute m-0" style={`max-height: ${maxHeight};`}>
            <div class="ns-autocomplete-inner w-full flex flex-col gap-8 lg:flex-row lg:gap-0">

                <div className="ns-autocomplete-group ns-keywords-group">
                    <div>
                        {popularSearches?.length > 0 && (
                            <>
                            <h3 id="ns-history-keywords" className="ns-autocomplete__header text-left caps-md mt-0 mb-4 p-0 !text-grey-5">
                                Popular Suggestions
                            </h3>
                            <ul className="text-left list-unstyled p-0 m-0" aria-labelledby="ns-history-keywords" role="group" ref={keywordsRef}>
                                {popularSearches?.slice(0, defaultConfig.historySize).map(item => (
                                    item.url ? (
                                        <li key={item.text} className="ns-autocomplete__keyword-item" role="option" aria-selected="false">
                                            <a href={item.url} className="ns-autocomplete-element w-full flex flex-nowrap cursor-pointer no-underline">
                                                <p className="text-black text-sm m-0">
                                                    {item.text}
                                                </p>
                                            </a>
                                        </li>
                                    ) : (
                                        <li key={item.text} className="ns-autocomplete__keyword-item" role="option" aria-selected="false">
                                            <HistoryElement query={{ query: item.text }} className="w-full flex flex-nowrap cursor-pointer">
                                                <p className="text-black text-sm m-0">
                                                    {item.text}
                                                </p>
                                            </HistoryElement>
                                        </li>
                                    )
                                ))}
                            </ul>
                            </>
                        )}
                    </div>
                </div>
                
                <div className="ns-autocomplete-group ns-products-group">
                    <div className="nosto_element" id={HISTORY_DROPDOWN_REC_ID}></div>
                </div>

            </div>
        </div>
    )
}
